import { INBOX_PREVIEW_ITEMS } from './previewItems.js';

export const INVITED_QUOTE = {
  id: 'q-2104',
  status: 'INVITED',
  price: null,
  dateOffered: null,
  receptor: {
    id: 'org-r',
    name: 'Receptor',
    primaryEmail: 'dev@tesseron.cl',
  },
  caseId: 'case-1',
  caseRol: 'C-2104-2026',
  caseTitle: 'Muñoz',
  createdAt: '2026-09-12T12:00:00.000Z',
  paidAt: null,
  taskId: 'task-1',
  taskCommune: 'Las Condes',
  taskDeadline: '2026-09-14T23:59:59.999Z',
  taskNotes: 'Notificación personal',
  taskAddress: 'Av. Apoquindo 3000',
  taskAddressDetails: 'Of. 1201',
  taskRegion: 'Metropolitana',
  firmName: 'Estudio Silva',
  tribunalName: '1º Juzgado Civil de Santiago',
  updatedAt: '2026-09-12T12:00:00.000Z',
};

// A second local quote derives its visible data from the existing inbox
// fixture. No address is invented for a list item that has none.
export const PREVIEW_QUOTES = [
  INVITED_QUOTE,
  {
    ...INVITED_QUOTE,
    id: 'q-882',
    caseId: 'case-2',
    taskId: 'task-2',
    caseRol: INBOX_PREVIEW_ITEMS[1].rol,
    caseTitle: 'Lagos',
    firmName: 'BCI',
    taskNotes: INBOX_PREVIEW_ITEMS[1].tipo,
    taskCommune: INBOX_PREVIEW_ITEMS[1].comuna,
    taskDeadline: INBOX_PREVIEW_ITEMS[1].taskDeadline,
    taskAddress: null,
    taskAddressDetails: null,
  },
];

// Answered quotes, for the Respondidas preview and the detail preview.
// dateOffered carries the chosen day at the end of the UTC day, as the API
// returns it.
export const OFFERED_QUOTE = {
  ...INVITED_QUOTE,
  id: 'q-130',
  status: 'OFFERED',
  price: '45000',
  dateOffered: '2026-10-28T23:59:59.999Z',
  caseId: 'case-3',
  taskId: 'task-3',
  caseRol: 'C-130-2025',
  caseTitle: 'Rojas',
};

export const PAID_QUOTE = {
  ...OFFERED_QUOTE,
  id: 'q-130-pagada',
  paidAt: '2026-10-20T15:00:00.000Z',
};

// DECLINED with the offer kept: the firm paid another receptor and the API
// declined this sibling quote.
export const LOST_QUOTE = {
  ...OFFERED_QUOTE,
  id: 'q-130-no-elegida',
  status: 'DECLINED',
};

// DECLINED without a price: closed for this receptor, with no offer to show.
export const DECLINED_QUOTE = {
  ...INVITED_QUOTE,
  id: 'q-11',
  status: 'DECLINED',
  caseId: 'case-4',
  taskId: 'task-4',
  caseRol: 'C-11-2026',
  caseTitle: 'Soto',
};

// An open request with the actuation fields of REC-1966: a Conservador filing
// with its inscription and two recipients, one with its own domicile.
export const ACTUATION_QUOTE = {
  ...INVITED_QUOTE,
  id: 'q-1966',
  caseRol: 'C-1966-2026',
  taskNotes: 'Coordinar con conserjería.',
  actuationType: 'GESTION_CONSERVADOR',
  actuationTypeOther: null,
  addressType: 'LABORAL',
  procedure: 'Ejecutivo Obligación de Dar',
  procedureKind: 'EJECUTIVO',
  conservador: {
    fojas: '1234 vta',
    numero: '1567',
    anio: '2019',
    registro: 'Propiedad',
  },
  recipients: [
    { kind: 'EMPRESA', representatives: 2 },
    {
      kind: 'PERSONA',
      address: 'Los Leones 120',
      addressType: 'PARTICULAR',
      commune: 'Providencia',
      region: 'Metropolitana',
    },
  ],
};

// An offer priced per recipient (REC-1983) on the request above.
export const OFFERED_BREAKDOWN_QUOTE = {
  ...ACTUATION_QUOTE,
  id: 'q-1983',
  status: 'OFFERED',
  price: '90000',
  dateOffered: '2026-09-13T23:59:59.999Z',
  payoutAccount: { bankCode: '012', accountType: 'vista', last4: '6789' },
  priceBreakdown: {
    items: [
      {
        recipientIndex: 0,
        unitAmount: 30000,
        units: 2,
        surcharge: 5000,
        amount: 65000,
      },
      {
        recipientIndex: 1,
        unitAmount: 25000,
        units: 1,
        surcharge: 0,
        amount: 25000,
      },
    ],
    total: 90000,
  },
};

export const ANSWERED_PREVIEW_QUOTES = [
  OFFERED_QUOTE,
  PAID_QUOTE,
  LOST_QUOTE,
  DECLINED_QUOTE,
];
